import { useMemo } from "react"
import { useQuery } from "@tanstack/react-query"
import type { KpiCatalogEntry } from "@nexus/contracts"
import { useAuth } from "@/features/auth/hooks/useAuth"
import { kpiCatalogQueryOptions, type KpiCatalogScope } from "@/lib/queries/kpi-catalog.queries"
import { buildMetricCatalog, catalogById, type MetricCatalogEntry } from "@/features/overview/lib/metricCatalog"
import {
  buildMyBrandKpiCatalog,
  myBrandCatalogById,
  type MyBrandKpiCatalogEntry,
} from "@/features/drilldown/lib/my-brand-kpi-catalog"

export function useKpiCatalog(scope: KpiCatalogScope) {
  const tenantId = useAuth((s) => s.activeTenantId) ?? ""
  const query = useQuery(kpiCatalogQueryOptions(scope, tenantId))
  const rows: KpiCatalogEntry[] = query.data ?? []

  const metricCatalog: MetricCatalogEntry[] = useMemo(() => buildMetricCatalog(rows), [rows])
  const metricById = useMemo(() => catalogById(metricCatalog), [metricCatalog])
  const myBrandCatalog: MyBrandKpiCatalogEntry[] = useMemo(() => buildMyBrandKpiCatalog(rows), [rows])
  const myBrandById = useMemo(() => myBrandCatalogById(myBrandCatalog), [myBrandCatalog])
  const visible = useMemo(() => rows.filter((row) => row.visible), [rows])

  return {
    ...query,
    rows,
    visible,
    metricCatalog,
    metricById,
    myBrandCatalog,
    myBrandById,
  }
}
